import { resolveUnref } from '@vueuse/core'
import { computed } from 'vue'

export function useSport (sport) {
  const sports = new Map(
    [
      [50, { name: '축구', num: 0, icon: 'soccer' }],
      [53, { name: '농구', num: 0, icon: 'basketball' }],
      [56, { name: '야구', num: 0, icon: 'baseball' }],
      [54, { name: '배구', num: 0, icon: 'volleyball' }],
      [51, { name: '아이스하키', num: 0, icon: 'ice-hockey' }],
      [95, { name: 'E-Sports', num: 0, icon: 'e-sports' }],
      [63, { name: '미식축구', num: 0, icon: 'american-football' }],
      [52, { name: '테니스', num: 0, icon: 'tennis' }],
      [55, { name: '핸드볼', num: 0, icon: 'handball' }],
      [70, { name: '탁구', num: 0, icon: 'table-tennis' }],
      [78, { name: '배드민턴', num: 0, icon: 'badminton' }],
      [90, { name: '격투기', num: 0, icon: 'combat' }],
    ],
  )

  const liveSports = new Map(
    [
      [50, { name: '축구', num: 0, icon: 'soccer' }],
      [53, { name: '농구', num: 0, icon: 'basketball' }],
      [56, { name: '야구', num: 0, icon: 'baseball' }],
      [54, { name: '배구', num: 0, icon: 'volleyball' }],
      [51, { name: '아이스하키', num: 0, icon: 'ice-hockey' }],
      [95, { name: 'E-Sports', num: 0, icon: 'e-sports' }],
    ]
  )

  const icon = computed(() => {
    const resolved = resolveUnref(sport)

    return sports.get(resolved).icon
  })

  return {
    sports,
    liveSports,
    icon
  }
}
